import { VoiceRecorderUI } from './components/voice-recorder';

export default function App() {
  return (
    <div className="flex min-h-screen flex-col bg-bg">
      <header className="flex items-center justify-between border-b border-border bg-surface px-4 py-4">
        <h1 className="font-display text-xl font-semibold text-primary">SupplySage Rep</h1>
        <span className="text-xs text-text-muted">P5 voice pipeline</span>
      </header>
      <main className="flex flex-1 flex-col">
        <VoiceRecorderUI />
      </main>
    </div>
  );
}
